<template>
  <el-select v-model="searchValue" placeholder="请选择" size="small" style="width: 300px;">
    <el-option
        v-for="item in list"
        :key="item.id"
        :label="item.name"
        :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
import {getAgentList} from './api'

export default {
  name: 'SelectDept',

  props: {
    value: {
      type: [String],
      default: () => ''
    },
  },

  computed: {
    searchValue: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  data() {
    return {
      list: [],
    }
  },

  created() {
    this.getList()
  },

  methods: {
    async getList() {
      this.list = await getAgentList()
    },
  }
}
</script>

<style></style>
